import { render, staticRenderFns } from "./oauth-done.vue?vue&type=template&id=00bb08fe"
import script from "./oauth-done.vue?vue&type=script&lang=js"
export * from "./oauth-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports